import usefulInformationRoutes from './config/usefulInformation';
import contactRoutes from './config/contact';
import medicalCenterRoutes from './config/medicalCenter';
import preventionRoutes from './config/prevention';
import onlineProceduresRoutes from './config/onlineProcedures';
import defaultRoutes from './config/default';
import userRoutes from './config/userRoutes';
import fullPagesRoutes from './config/fullPages';

export default [
  ...defaultRoutes,
  ...usefulInformationRoutes,
  ...contactRoutes,
  ...medicalCenterRoutes,
  ...preventionRoutes,
  ...onlineProceduresRoutes,
  ...userRoutes,
  ...fullPagesRoutes,
];
